import { useInviteClientModal } from '@entities/clients/heplers.ts';
import { formatDistanceStrict, parseISO } from 'date-fns';
import { ru } from 'date-fns/locale';
import type React from 'react';
import { ModerationCircle } from '@shared/assets';
import { useWindowWidth } from '@shared/hooks';
import type { Client } from '@shared/types/users';
import * as st from './styles.module.scss';

type Props = {
  client: Client;
};

export const Info: React.FC<Props> = ({ client }) => {
  const windowWidth = useWindowWidth();
  const { openInviteModal } = useInviteClientModal();
  const date = formatDistanceStrict(
    new Date(),
    client?.birth_date ? parseISO(client?.birth_date) : new Date(),

    {
      unit: 'year',
      locale: ru,
    }
  );
  const gender = client?.gender === 'm' ? 'Мужчина' : client?.gender === 'f' ? 'Женщина' : '';

  return client ? (
    <section className={st.wrapper}>
      <p className={st.info}>
        {gender && date !== '0 лет' && `${gender}, ${date}`}
        {gender && date === '0 лет' && `${gender}`}
        {!gender && date !== '0 лет' && `${date}`}
        {!gender && date == '0 лет' && ''}
      </p>

      <div className={st.last_row}>
        {/*<p className={st.info}>*/}
        {/*  {client.phone.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, `$1 ($2) $3-$4-$5`)}*/}
        {/*</p>*/}
        <div className={st.info__moderation} onClick={openInviteModal}>
          {!client?.is_registered && (
            <>
              {windowWidth > 450 && (
                <span className={st.info__moderation__text}>Не является пользователем</span>
              )}

              <div className={st.info__moderation__icon}>
                <ModerationCircle />
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  ) : undefined;
};
